import React from 'react';

import "./manning-online-latest.scss";
import { ManningOnlineStore } from '../../store/ManningOnlineStore';
import { TaggedProductList } from '../../../ts/components/common/taggedProductList/TaggedProductList';
import { ProductCard } from '../../../ts/components/common/productCard/ProductCard';
import { News } from '../news/News';
import { ManningOnlineStats } from '../manningOnlineStats/ManningOnlineStats';
import { ManningOnlineRecommend } from '../manningOnlineRecommend/ManningOnlineRecommend';
import { RecommendedChatUsers } from '../recommendedItems/RecommendedChatUsers';
import { TagList } from '../recommendedItems/TagList';
import { ReadingStack, ReadingStackDisplayType } from '../readingStack/ReadingStack';
import { IReadingList } from '../../models/ReadingList';
import { IProductDescription } from '../../../ts/models/product/IProductDescription';
import { ReadingList } from '../../../ts/components/common/readingList/ReadingList';

import TakeALiveTestBanner from '../../../learning-components/testYourself/TakeALiveTestBanner';
import { ForYou } from '../forYou/ForYou';
import { DeploymentType, SourceApp } from '../../../Config';
import { RecentReadingList } from '../forYou/RecentReadingList';

export interface IProps {
    store: ManningOnlineStore;
    handleShowTestYourselfModal: (show: boolean) => void;

    deploymentType: DeploymentType;
    sourceApp: SourceApp;
}

export interface IState {
    selectedReadingList: IReadingList;
    showTestYourselfModal?: boolean;
}

export class ManningOnlineLatest extends React.Component <IProps, IState> {
    private hasBeenMounted: boolean;
    
    constructor(props: IProps) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleSelectReadingList = this.handleSelectReadingList.bind(this);
        this.handleSelectedReadingListRef = this.handleSelectedReadingListRef.bind(this);
        this.handleReadingListsSectionRef = this.handleReadingListsSectionRef.bind(this);
        this.handleUnselectReadingList = this.handleUnselectReadingList.bind(this);
        this.handleReadingListDelete = this.handleReadingListDelete.bind(this);
        this.handleShowTestYourselfModal = this.handleShowTestYourselfModal.bind(this);
        this.handleResumeButtonClick = this.handleResumeButtonClick.bind(this);

        this.state = {
            selectedReadingList: null,
            showTestYourselfModal: false
        };
    }

    public componentDidMount(){
        this.hasBeenMounted = true;

        this.props.store.onReadingListChange(this.handleChange);
    }

    public componentWillUnmount(){
        this.hasBeenMounted = false;

        this.props.store.offReadingListChange(this.handleChange);
    }

    private handleChange(){
        this.hasBeenMounted && this.forceUpdate();
    }

    private handleShowTestYourselfModal() {
        this.props.handleShowTestYourselfModal(false);
        // this.setState({ showTestYourselfModal: false }, () => console.log('handleShowTestYourselfModal', this.state.showTestYourselfModal));
    }

    public render(){
        return <div className="manning-online-latest-root">
                    {/* <div className="manning-online-latest-top-row"><RecentReadingList sourceApp={this.props.sourceApp} deploymentType={this.props.deploymentType}/></div> */}
                        
                    <div className='manning-online-left-column'>
                        { this.renderTeamDashboardLinkIfNeeded()}
                        <ForYou news={this.props.store.catalogState.news} store={this.props.store} sourceApp={this.props.sourceApp} deploymentType={this.props.deploymentType}/>
                    </div>
                   
                    <div className='manning-online-right-column'>
                        { this.renderTeamDashboardLinkIfNeeded()}
                        <div id="manning-online-recent-reading-container">
                            {this.renderRecentReading()}
                        </div>
                        <div id="manning-online-reading-lists-container">
                            {this.renderReadingLists()}
                        </div>
                        {this.renderTakeALiveTestBanner()}
                        {/* <ManningOnlineStats store={this.props.store}/> */}

                        <div className="manning-online-latest-following-stats-recommendations">
                        {this.renderTopics()}
                        {/*this.renderRecommendedUsers()*/}
                       
                        </div>
                    </div>
                    { this.renderSelectedReadingList()}
               </div>
    }

    private renderTakeALiveTestBanner(){
        return <TakeALiveTestBanner deploymentType={this.props.deploymentType} sourceApp={this.props.sourceApp} handleShowTestYourselfModal={() => this.handleShowTestYourselfModal()} />
    }

    private renderSelectedReadingList(){
        const readingList = this.state.selectedReadingList;
        if(readingList == null) { return null; }

        return <div className='manning-online-latest-selected-reading-list-container'>
                    <ReadingList key={readingList.id} 
                                 readingList={readingList}
                                 onRef={this.handleSelectedReadingListRef}
                                 store={this.props.store}
                                 onCloseClick={this.handleUnselectReadingList}/>
                </div>
    }

    private readingListSectionRoot: HTMLElement;
    private handleReadingListsSectionRef(readingListSectionRoot){
        if(readingListSectionRoot){
            this.readingListSectionRoot = readingListSectionRoot.root;
        }
        else {
            this.selectedReadingListRoot = null;
        }
    }

    private selectedReadingListRoot: HTMLElement;
    private handleSelectedReadingListRef(selectedReadingListRoot){
        if(selectedReadingListRoot){
            this.selectedReadingListRoot = selectedReadingListRoot.parentElement;
            setTimeout(() => {
                if(this.hasBeenMounted && this.selectedReadingListRoot != null){
                    let currentReadingListIndex = this.getCurrentReadingListIndex();
                    let x = 0, y = 0;

                    if(this.readingListSectionRoot != null){
                        const offset = this.readingListSectionRoot.getBoundingClientRect();
                        if(offset != null){
                            x = offset.x + 110 * currentReadingListIndex + 110/2;
                            y = offset.y + 135/2;
                        }
                    }
                    
                    this.selectedReadingListRoot.style.transformOrigin = `${x}px ${y}px `;
                    this.selectedReadingListRoot.classList.add("appear");
                }
            }, 16);
        }
        else {
            this.selectedReadingListRoot = null;
        }
    }

    private getCurrentReadingListIndex(): number {
        if(!this.state.selectedReadingList) { return -1; }

        const allReadingLists = this.props.store.getDisplayedReadingLists();

        for(let i = 0; i < allReadingLists.length; i++){
            if(allReadingLists[i].id == this.state.selectedReadingList.id) { return i; }
        }

        return -1;
    }

    private renderTeamDashboardLinkIfNeeded(){
        if(!this.props.store.isSubscriptionOwner
        || this.props.store.subscriptionType != "TEAM"
        || !this.props.store.subscriptionId) { return null; }
        
        return <div className='_team-dashboard-link'>
                    <a href={`https://subscription${this.props.deploymentType == DeploymentType.qa ? "-qa" : ""}.manning.com/manning-online-corporate/${this.props.store.subscriptionId}`}>manage your team</a>
               </div>;
    }

    private renderRecentReading(){
        const productList = this.props.store.catalogState.recentReading;
        // const productList = this.props.store.getDisplayedReadingLists()[0]?.products;
        if(!productList || productList.length == 0) { return null; }
        
        return <TaggedProductList key={"recent reading"} tag={"continue reading"} 
                                  showSlideArrows={true}
                                  showMoreInfoCardOnClick={false}
                                  store={this.props.store}>
                    { productList.map(it => 
                        <ProductCard key={it.id}
                                     onHoverLabel={!it.isDummy ? "resume" : ""}
                                     productDescription={it} 
                                     coverPlaceholder={this.props.store.coverPlaceholder}
                                     wideCoverPlaceholder={this.props.store.wideCoverPlaceholder}
                                     showPercentage={true}
                                     percentageRead={it.percentageRead}
                                     data={`${it.manningId}`}
                                     onResumeButtonClick={()=>this.handleResumeButtonClick(it.manningId)}
                                     onDragStart={this.props.store.catalogState.coversAreDraggable ? this.props.store.onProductCoverDragStart : null}/>)}
                </TaggedProductList>
    }

    private handleResumeButtonClick(manningId: string){
        this.props.store.logAction(`resumeButtonClick--${manningId}`);
    }

    private renderReadingLists(){
        const readingLists = this.props.store.getDisplayedReadingLists();
        if(readingLists == null || readingLists.length == 0) { return null; }
        
        return  <TaggedProductList key={"your reading lists"} tag={"your reading lists"} 
                                  showSlideArrows={true}
                                  className={"reading-list"}
                                  showMoreInfoCardOnClick={false}
                                  store={this.props.store}
                                  ref={this.handleReadingListsSectionRef}>
                    { readingLists.map(it => <ReadingStack store={this.props.store} displayType={ReadingStackDisplayType.StackedInRow} 
                                                           readingList={it} key={it.id + it.title}
                                                           onAddToReadingList={productId => this.handleAddToReadingList(it, productId)}
                                                           onSelectReadingList={this.handleSelectReadingList}
                                                           />) }
                    </TaggedProductList>
    }

    private renderTopics(){
        const store = this.props.store;
        const tags = store.getAllTags();
        return <div className="manning-online-latest-recommended-topics manning-online-latest-section">
                { tags != null && tags.length > 0 && <>
                    <div className="manning-online-latest-section-title manning-online-latest-topics">topics you might be interested in</div>
                    <TagList store={this.props.store} replacementIcon="fa-tag"/>
                  </> }
                </div>
    }

    private renderRecommendedUsers(){
        return null;
        /*const suggestedUsers = this.props.store.chatStore.state.suggestedUsers;
        return <div className="manning-online-latest-recommended-people manning-online-latest-section">
                    {suggestedUsers != null && suggestedUsers.length > 0
                  && <>
                        <div className="manning-online-latest-section-title">connect with readers</div>
                        <RecommendedChatUsers recommendedUsers={suggestedUsers}
                                              store={this.props.store}/>
                     </>} 
                </div>*/
    }

    private handleAddToReadingList(readingList: IReadingList, productId: any): void {
        this.props.store.addToReadingListByProductId(readingList, productId).then(() => {
            if(!readingList.title || readingList.title == "unnamed"){
                this.handleReadingListNameChange(readingList);
            }
        });
    }

    private handleReadingListNameChange(readingList: IReadingList){
        const newTitle = prompt(readingList.title ? "Change title": "Enter title", readingList.title);
        if(newTitle){
            this.props.store.updateReadingListTitle(readingList, newTitle);
        }
    }

    private handleReadingListDelete(readingList: IReadingList){
        const title = readingList.title || readingList.products[0].title;
        if(confirm(`Delete list ${title}?`)){
            this.props.store.deleteReadingList(readingList);
            this.setState({
                selectedReadingList: null
            });
        }
    }

    private handleSelectReadingList(readingList: IReadingList){
        this.setState({
            selectedReadingList: readingList
        });

        this.props.store.getProductsPercentageFinished(readingList.products.map(it => it.manningId)).then((map) => {
            readingList.products.forEach(product => {
                product.percentageRead = map[product.manningId] || 0;
            })
            
            this.hasBeenMounted && this.forceUpdate();
        });
    }

    private handleUnselectReadingList(){
        if(this.selectedReadingListRoot){
            this.selectedReadingListRoot.classList.remove("appear");
            setTimeout(() => {
                this.hasBeenMounted && this.setState({
                    selectedReadingList: null
                });
            }, 200)
        }
    }

    private onRemoveProductClick(readingList: IReadingList, productDescription: IProductDescription){
        if(readingList.products.length == 1 
        && readingList.products[0].manningId == productDescription.manningId){
            this.props.store.deleteReadingList(readingList);
            this.handleUnselectReadingList();
            return;
        }
        
        this.props.store.removeProductFromReadingList(readingList, productDescription);
    }
}